'use strict';

angular.module('oddQuestionnaireTemplateModule', [
    'ngFileUpload'
]);